import React, { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input.tsx";
import { createList } from "@/api/offline.ts";
import { addStateEntry, listsState, uiState } from "@/states.ts";
import { processQueue } from "@/api/queue.ts";
import { Button } from "@/components/ui/button.tsx";
import { useLocation } from "wouter";
import * as Dialog from "@radix-ui/react-dialog";
import { randomColor } from "@/lib/utils.ts";
import { useIsMobile } from "@/hooks/use-mobile.tsx";
import { ColorPicker } from "@/components/ColorPicker.tsx";

const NewListDialog: React.FC = (props) => {
	const [title, setTitle] = useState("");
	const [location, setLocation] = useLocation();
	const [color, setColor] = useState(randomColor());
	const inputRef = useRef<HTMLInputElement | null>(null);
	const isMobile = useIsMobile();
	// TODO errors

	const handleCreateList = (e: React.SyntheticEvent) => {
		e.preventDefault();
		if (!title) {
			// TODO
			return;
		}
		createList(title, color).then((l) => {
			addStateEntry(listsState.lists, l.list, true);
			setLocation(`/lists/${l.list.id}/items`);
			uiState.newList = false;
		});
		processQueue();
	};

	const handleClose = () => {
		uiState.newList = false;
	};
	useEffect(() => {
		if (!isMobile || !inputRef.current) {
			return;
		}
		inputRef.current?.scrollIntoView();
	}, [isMobile, inputRef]);

	return (
		<>
			<Dialog.Root open={true}>
				<Dialog.Portal>
					<Dialog.Overlay className="DialogOverlay" />
					<Dialog.Content className={"DialogContent"}>
						<form
							onSubmit={handleCreateList}
							className={"p-4 flex flex-col space-y-2"}
						>
							<Dialog.Title className="DialogTitle">
								New List
							</Dialog.Title>
							<div className={"flex items-center gap-4"}>
								<Input
									ref={inputRef}
									placeholder={"Title"}
									value={title}
									className={
										"bg-secondary/30"
									}
									onChange={(e) =>
										setTitle(
											e.target
												.value,
										)
									}
								/>
								<ColorPicker
									color={color}
									onChange={(c) =>
										setColor(c)
									}
								/>
							</div>
							<div className="flex gap-4 justify-end pt-4">
								<Button
									type={"button"}
									variant={"ghost"}
									onClick={handleClose}
								>
									Cancel
								</Button>
								<Button
									type={"submit"}
									onClick={handleCreateList}
								>
									Create
								</Button>
							</div>
						</form>
					</Dialog.Content>
				</Dialog.Portal>
			</Dialog.Root>
		</>
	);
};

export { NewListDialog };
